import { getDatePeriod } from '@/helpers/dateHelper';
import { useMapToLeaveTypeId } from '@/services/availability/useAvailabilityTypes';
import {
  AvailabilityException,
  RosteredEmployeeIdAndSchedule,
  WorkingPatternDay
} from '@/services/gql/graphql.generated';
import { useGetDayOfWeekAndHoliday } from '@/services/holiday/usePublicHolidays';
import { useCallback, useMemo } from 'react';
import { buildSchedule } from './buildSchedule';

export const useBuildSchedule = (startDate: Date, endDate: Date) => {
  const mapToLeaveTypeId = useMapToLeaveTypeId();

  const dates = useMemo(() => getDatePeriod(startDate, endDate), [startDate, endDate]);

  const getDayOfWeekAndHoliday = useGetDayOfWeekAndHoliday(startDate);

  return useCallback(
    (patterns: WorkingPatternDay[], exceptions: AvailabilityException[], shifts: RosteredEmployeeIdAndSchedule[]) => {
      const buildScheduleFunction = buildSchedule(dates, mapToLeaveTypeId, getDayOfWeekAndHoliday);

      return buildScheduleFunction(patterns, exceptions, shifts);
    },
    [dates, mapToLeaveTypeId, getDayOfWeekAndHoliday]
  );
};
